import React, { Component } from 'react'
import { Flex, WhiteSpace, Toast } from 'antd-mobile'
import './index.css'
import loginImg from '../../assets/imgs/login.png'
import T from '../../utils/language'
import { cleanAuth } from '../../utils/storage'
import { validationUserPassword } from '../../utils/validation'
import { login } from '../../apis'
import md5 from 'js-md5'
import { EyeInvisibleOutline, EyeOutline } from 'antd-mobile-icons'

export default class Login extends Component {
  state = {
    account: '',
    password: '',
    showPassword: false,
  }

  componentDidMount() {
    if (!localStorage.getItem('accountId') && localStorage.getItem('token')) {
      cleanAuth()
    }
  }

  handleChangeAccount(e) {
    const { value } = e.target
    this.setState({
      account: value,
    })
  }

  handleChangePassword(e) {
    const { value } = e.target
    this.setState({
      password: value,
    })
  }

  validateData() {
    const { account, password } = this.state
    return account !== '' && password !== ''
  }

  handLogin() {
    const { account, password } = this.state
    if (!this.validateData()) {
      Toast.fail('账号或密码不能为空', 2)
      return false
    }
    Toast.loading(T('加载中…'), 30)
    // 密码md5加密
    login({
      username: account,
      password: md5(password),
      verification: validationUserPassword(password) ? 1 : 2,
    })
      .then((res) => {
        const {
          identityId,
          countryId,
          accessToken,
          role,
          accessJwtToken,
          refreshToken,
          code,
        } = res
        if (code === 49030) {
          Toast.fail(T('密码不符合规则，请在CMS后台进行修改'), 2)
          return
        }
        localStorage.setItem('accountId', identityId)
        localStorage.setItem('time', new Date().getTime())
        localStorage.setItem('countryId', countryId)
        localStorage.setItem('token', accessToken)
        localStorage.setItem('accessJwtToken', `Basic ${accessJwtToken}`)
        localStorage.setItem('refreshToken', refreshToken)
        // jp only for eject role
        localStorage.setItem('role', role)
        Toast.hide()
        // HACK: use frontend auth redirect
        window.location.reload()
      })
      .catch((err) => {
        Toast.hide()
        Toast.fail(err, 2)
        console.error(err)
      })
  }

  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }

  render() {
    const { account, password, showPassword } = this.state
    return (
      <div>
        <div className="login">
          <img src={loginImg} alt="chargespot" className="login-img" />
          <div className="login-block">
            <Flex justify="center" direction="column">
              <h3>{T('ChargeSPOT 出厂绑定设置')}</h3>
              <div className="login-form">
                <div className="login-input-container">
                  <input
                    autoComplete="username"
                    type="text"
                    placeholder={T('账号')}
                    value={account}
                    onChange={this.handleChangeAccount.bind(this)}
                  />
                </div>
                <WhiteSpace />
                <div className="login-input-container">
                  <input
                    autoComplete="current-password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder={T('密码')}
                    value={password}
                    onChange={this.handleChangePassword.bind(this)}
                  />
                  <button
                    className="login-input-icon-button"
                    onClick={this.toggleShowPassword}
                  >
                    {showPassword ? (
                      <EyeInvisibleOutline fontSize={24} />
                    ) : (
                      <EyeOutline fontSize={24} />
                    )}
                  </button>
                </div>
                <WhiteSpace />
                <button
                  type="button"
                  className="submit-btn"
                  onClick={this.handLogin.bind(this)}
                >
                  {T('登录')}
                </button>
              </div>
            </Flex>
          </div>
        </div>
        <p className="forget-pwd">{T('忘记密码联系管理员修改')}</p>
      </div>
    )
  }
}
